import { type LabRequisitions } from '../types/types'
import { getRequisitionResultSets } from '../utils/requisitionUtils'

export type PendingReportPollingState = { key: string; deadline: number }

/** Ten minutes of foreground refresh per pending set; expiry is never a rejection verdict. */
export const pendingReportRefetchInterval = (
  requisitions: LabRequisitions | undefined,
  state: PendingReportPollingState,
  now: number
): number | false => {
  const key = (requisitions ?? [])
    .flatMap(getRequisitionResultSets)
    .filter((result) => result.reportUploadState === 'PENDING')
    .map((result) => result.resultId)
    .sort((a, b) => a - b)
    .join(',')
  if (key !== state.key) {
    state.key = key
    state.deadline = now + 10 * 60 * 1000
  }
  return key && now < state.deadline ? 5000 : false
}
